module.exports = __WEBPACK_EXTERNAL_MODULE_68__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-chart-creator"
// module id = 68
// module chunks = 0